import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import selectors from '../../rootSelectors';
import { setShouldDisplayCaption } from '../screen/screenActions';
import { ARIA_LABELS } from '../../constants/text';
import CloseButton from '../../images/vector/close-btn.svg';

const Captions = () => {
    const dispatch = useDispatch();
    const captionRef = useRef(null);
    const [scrollLength, setScrollLength] = useState(0);
    const [scrollPosition, setScrollPosition] = useState(0);

    const isCaptionDisplayed = useSelector(selectors.getShouldDisplayCaption);
    const caption = useSelector(selectors.getCaption);
    const isAvatarSpeaking = useSelector(selectors.getAvatarSpeaking);
    const isAnimationDisabled = useSelector(selectors.getIsAnimationDisabled);
    const isPaused = useSelector(selectors.getIsPaused);
    const isHelpPopupVisible = useSelector(selectors.getIsHelpPopupVisible);
    const isConfirmPopupActive = useSelector(selectors.isConfirmPopupActive);

    const SCROLL_RATE = 1000;

    const scrollCaptionDown = () => {
        if (scrollLength && (captionRef.current.scrollTop < scrollLength - 1)) {
            captionRef.current.scrollBy({ top: 3, behavior: 'smooth' });
        }
    };

    const resetScrolling = position => {
        setScrollPosition(position);
        setScrollLength(0);
    };

    // Set initial scrollLength value for when caption exceeds 2 lines
    useEffect(() => {
        if (captionRef && captionRef.current && !scrollLength && isAvatarSpeaking && isCaptionDisplayed) {
            setScrollLength(captionRef.current.scrollHeight - captionRef.current.offsetHeight);
        }
    }, [isAvatarSpeaking, isCaptionDisplayed]);

    // Start scrolling caption (initially or after resuming from pause)
    useEffect(() => {
        if (scrollLength && isAvatarSpeaking) {
            captionRef.current.scrollTop = scrollPosition;
            const scrollInterval = setInterval(scrollCaptionDown, SCROLL_RATE);
            return () => clearInterval(scrollInterval);
        }
        return () => {};
    }, [scrollLength, isAvatarSpeaking]);

    // Save scroll position and reset scrolling process
    useEffect(() => {
        if (scrollLength) {
            if (isPaused) {
                resetScrolling(captionRef.current.scrollTop);
            } else if (!isCaptionDisplayed) {
                resetScrolling(0);
            }
        }
    }, [isPaused, isCaptionDisplayed]);

    const hideCaption = () => dispatch(setShouldDisplayCaption(!isCaptionDisplayed));

    return (
        isCaptionDisplayed && (
            <div aria-hidden={isHelpPopupVisible} className="audio-caption-wrapper" ref={captionRef}>
                <div className="audio-caption-container">
                    <span className="audio-caption">
                        {`${isAnimationDisabled ? 'Narrator' : 'Alyx'}: ${caption}`}
                    </span>
                    <button
                        aria-label={ARIA_LABELS.HIDE_CAPTION}
                        className="hide-audio-caption"
                        disabled={isHelpPopupVisible || isConfirmPopupActive}
                        onClick={hideCaption}
                    >
                        <CloseButton />
                    </button>
                </div>
            </div>
        )
    );
};

export default Captions;
